import { useState, useContext } from 'react';
import axios from 'axios';
import { UserContext } from './UserContext';

export default function useAuth() {
  const { setUser } = useContext(UserContext);
  const [error, setError] = useState(null);

  //set user in context
  const setUserContext = async (data) => {
    setUser(data);
    localStorage.setItem('userID', JSON.stringify(data.id));
    localStorage.setItem('token', data.token);
  }

  //login user
  const loginUser = async (credentials) => {
    try {
      const response = await axios.post(`/api/tokens`, {
        email: credentials.email,
        password: credentials.password,
      }, {
        headers: { 'Content-Type': 'application/json' },
      });
      setUserContext(response.data);
      return true;
    } catch (err) {
      setError(err.response?.data);
      return false;
    }
  }

  return {
    loginUser,
    error
  }
}